import styled from 'styled-components'

export const ToggledStyledContainer = styled.div`
 position: relative;
`

export const ToggledStyled = styled.div`
	visibility: ${({ visibleBlock }) => visibleBlock ? 'visible' : 'hidden'};
	height: ${({ visibleBlock }) => visibleBlock ? 'auto' : '0'};
	overflow: ${({ visibleBlock }) => visibleBlock ? '0' : 'hidden'};
	& + button {
		left: ${({ visibleBlock }) => visibleBlock ? '100%' : '7px'};
		border: none;
		position: absolute;
		top: -2px;
		transform: translateX(-100%);
		z-index: 1;
		background-color: #3e4c57;
		padding: 1px 8px;
		color: white;
		font-size: 18px;
		border-radius: 3px;
		&:hover {
			background-color: ${({ theme }) => theme.primaryHover};
			color: ${({ theme }) => theme.activeColor};
		}
	}
`
